import { Injectable } from '@angular/core';
import { BikeComponent, BikeComponentVariant } from '../components/component/component';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class DataParserService {

  constructor(private utilsService: UtilsService) { }

  public initComponents(
    components: any,
    oeOptionsListAll: { id: number, name: string }[],
    componentClassOptionsList: { id: number, name: string }[],
    hexComponentIdentifier?: boolean
  ): BikeComponent[] {
    return components.data.map((el: any) => {
      const componentEl: BikeComponent = {
        Component: this.getComponentClass(el.component_class, componentClassOptionsList),
        ComponentClass: el.component_class,
        ComponentIdentifier: hexComponentIdentifier ? "0x" + el.component_identifier.toString().toUpperCase() : el.component_identifier,
        ComponentName: el.component_name,
        SubcomponentIdentifier: el.subcomponent_identifier,
        Slot: el.slot,
        Id: el.id,
        OEMId: el.OEM_ID,
        OEMName: this.utilsService.getOEMName(el.OEM_ID, oeOptionsListAll),
        Variants: el.variants.map((el: any) => { return this.getComponentVariant(el, oeOptionsListAll) }),
        AddOn: false
      };

      return componentEl;
    });
  }

  private getComponentVariant(variant: any, oeOptionsListAll: { id: number, name: string }[]): BikeComponentVariant {
    const variantEl: BikeComponentVariant = {
      Id: variant.id,
      Name: variant.variant_name,
      Shared: variant.shared,
      OEMId: variant.OEM_ID,
      OEMName: this.utilsService.getOEMName(variant.OEM_ID, oeOptionsListAll)
    };

    return variantEl;
  }

  private getComponentClass(id: number, componentClassOptionsList: { id: number, name: string }[]): string {
    return componentClassOptionsList.find((el) => { return el.id == id })?.name as string;
  }
}
